/**
 * @desc 获取日期范围规则
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.AmazonDateRangeRulesResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/amazonDateRangeRules/getAmazonDateRangeList`, {
      method: "GET",

      ...options,
    }),
  );
}
